module.exports = __webpack_public_path__ + "img/youtube.6ec424b6.svg";